import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { P } from '#app/components/typography/p.tsx'
import { Q } from '#app/components/typography/q.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Q',
}

const component: componentProps = {
	name: 'Q',
	shortName: 'Q',
	fileName: 'q',
	category: 'typography',
	description: ['A short inline quotation.'],
	features: ['Drop-in replacement for the native <q> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<P>
	When Dave asks HAL to open the pod bay door, HAL answers:{' '}
	<Q cite="https://www.imdb.com/title/tt0062622/quotes/?item=qt0396921&ref_=ext_shr_lnk">I'm sorry, Dave. I'm afraid I can't do that.</Q>
</P>`,
	styling: `.q {
	@apply font-sans italic before:content-['“'] after:content-['”'];
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<P>
				When Dave asks HAL to open the pod bay door, HAL answers:{' '}
				<Q cite="https://www.imdb.com/title/tt0062622/quotes/?item=qt0396921&ref_=ext_shr_lnk">I'm sorry, Dave. I'm afraid I can't do that.</Q>
			</P>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
